import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  Typography,
  Stack,
  Divider,
  Avatar,
  useTheme,
} from "@mui/material";
import CallRoundedIcon from "@mui/icons-material/CallRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LanguageRoundedIcon from "@mui/icons-material/LanguageRounded";
import StarIcon from "@mui/icons-material/StarRounded";
import OpenInNewIcon from "@mui/icons-material/OpenInNewRounded";
import AddIcon from "@mui/icons-material/AddRounded";
import backgroundImg from "./assets/pexels-zain-naqvi-246994819-16285228.jpg";
import logoImg from "../../../assets/ce-logo_white.svg";

const OperationsCard = () => {
  const theme = useTheme();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Function to calculate relative time
  const getRelativeTime = (dateString) => {
    const reviewDate = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - reviewDate);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return "today";
    if (diffDays === 1) return "1 day ago";
    if (diffDays < 7) return `${diffDays} days ago`;
    if (diffDays < 14) return "1 week ago";
    if (diffDays < 30) return `${Math.floor(diffDays / 7)} weeks ago`;
    if (diffDays < 60) return "1 month ago";
    if (diffDays < 365) return `${Math.floor(diffDays / 30)} months ago`;
    if (diffDays < 730) return "1 year ago";
    return `${Math.floor(diffDays / 365)} years ago`;
  };

  // Generate random reviews
  const reviews = [
    {
      id: 1,
      name: "Ramy Abdelmaksoud",
      rating: 5,
      date: "09-26-2025",
      text: null,
      avatar: "RA",
      link: "https://maps.app.goo.gl/NkeNaHKU973fUWdp9",
    },
    {
      id: 2,
      name: "Milad Korkis",
      rating: 5,
      date: "11-26-2025",
      text: null,
      avatar: "MK",
      link: "https://maps.app.goo.gl/WgKtmHmB5BCuG5jP9",
    },
    {
      id: 3,
      name: "Angel Vasquez",
      rating: 5,
      date: "11-26-2025",
      text: null,
      avatar: "AV",
      link: "https://maps.app.goo.gl/xb3wwNLiABdj2fX3A",
    },
    {
      id: 4,
      name: "Vika Petrenko",
      rating: 5,
      date: "10-26-2025",
      text: "I called, and they started the process for the translation I asked them to do very quickly! Definitely recommend!!",
      avatar: "VP",
      link: "https://maps.app.goo.gl/GKhhNCmm1k55no189",
    },
    {
      id: 5,
      name: "Carine Nyaka",
      rating: 5,
      date: "12-26-2025",
      text: "Communication Essentials LLc, they conducted business professionally. So everybody go ahead work with them. Asante Sana!",
      avatar: "CN",
      link: "https://maps.app.goo.gl/rogmwn5rCg62UedP6",
    },
  ].reverse(); // Reverse so newest is first

  const contactItems = [
    {
      id: "phone",
      label: "Phone",
      value: "717 342 6827",
      href: "tel:+17173426827",
      icon: (
        <CallRoundedIcon
          sx={{ color: theme.palette.primary.main, fontSize: 40 }}
        />
      ),
    },
    {
      id: "email",
      label: "Email",
      value: "Operations@communicationessentialsllc.com",
      href: "mailto:Operations@communicationessentialsllc.com",
      icon: (
        <EmailRoundedIcon
          sx={{ color: theme.palette.primary.main, fontSize: 40 }}
        />
      ),
    },
    {
      id: "linkedin",
      label: "LinkedIn",
      value: "Communication Essentials LLC",
      href: "https://www.linkedin.com/company/111049209",
      icon: (
        <LinkedInIcon
          sx={{ color: theme.palette.primary.main, fontSize: 40 }}
        />
      ),
    },
    {
      id: "website",
      label: "Website",
      value: "communicationessentialsllc.com",
      href: "https://communicationessentialsllc.com",
      icon: (
        <LanguageRoundedIcon
          sx={{ color: theme.palette.primary.main, fontSize: 40 }}
        />
      ),
    },
  ];

  const handleSaveContact = () => {
    // Create vCard
    const vcard = `BEGIN:VCARD
VERSION:4.0
FN:Communication Essentials LLC
ORG:Communication Essentials LLC
TEL;TYPE=work,voice:+17173426827
EMAIL:Operations@communicationessentialsllc.com
URL:https://communicationessentialsllc.com
END:VCARD`;

    const blob = new Blob([vcard], { type: "text/vcard" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.setAttribute("download", "Communication_Essentials_LLC.vcf");
    link.href = url;
    link.click();

    URL.revokeObjectURL(url);
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        position: "relative",
        paddingTop: isMobile ? "10vh" : "12vh",
        paddingBottom: isMobile ? "2vh" : "3vh",
        overflow: "hidden",
        //display: "flex",
        //flexDirection: "column",
        //alignItems: "center",
        //justifyContent: "center",
      }}
    >
      {/* Background Image - Full Screen */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: "50%",
          transform: "translateX(-50%)",
          width: isMobile ? "100%" : "824px",
          height: "100%",
          zIndex: 0,
        }}
      >
        <Box
          component="img"
          src={backgroundImg}
          alt="Background"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center top",
          }}
        />
      </Box>

      {/* Main Card - wraps content */}
      <Box
        sx={{
          position: "relative",
          left: "50%",
          transform: "translateX(-50%)",
          width: isMobile ? "100%" : "90%",
          maxWidth: 500,
          background: theme.palette.background.alt,
          borderRadius: isMobile ? "16px" : "24px",
          boxShadow:
            "0 8px 32px rgba(0, 0, 0, 0.3), 0 4px 16px rgba(0, 0, 0, 0.2)",
          display: "flex",
          flexDirection: "column",
          zIndex: 5,
          pb: 1,
        }}
      >
        {/* Profile Picture Ripple - using box-shadow */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: isMobile ? 140 : 180,
            height: isMobile ? 140 : 180,
            borderRadius: "50%",
            backgroundColor: "transparent",
            zIndex: 7,
            "@keyframes ripple": {
              "0%": {
                boxShadow: `0 0 0 0 ${theme.palette.primary.main}33,
                            0 0 0 0.4em ${theme.palette.primary.main}33,
                            0 0 0 1.2em ${theme.palette.primary.main}33,
                            0 0 0 2.0em ${theme.palette.primary.main}33`,
              },
              "100%": {
                boxShadow: `0 0 0 0.4em ${theme.palette.primary.main}33,
                            0 0 0 1.2em ${theme.palette.primary.main}33,
                            0 0 0 2.0em ${theme.palette.primary.main}33,
                            0 0 0 2.8em ${theme.palette.primary.main}00`,
              },
            },
            animation: "ripple 1.2s linear infinite",
          }}
        />

        {/* Profile Picture - centered on top edge */}
        <Box
          component="img"
          src={logoImg}
          alt="Communication Essentials LLC"
          sx={{
            position: "absolute",
            top: 0,
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: isMobile ? 140 : 180,
            height: isMobile ? 140 : 180,
            borderRadius: "50%",
            border: isMobile ? `3px solid ${theme.palette.background.alt}` : `4px solid ${theme.palette.background.alt}`,
            objectFit: "contain",
            backgroundColor: theme.palette.primary.main,
            padding: isMobile ? "15px" : "20px",
            zIndex: 10,
          }}
        />

        {/* Card Content */}
        <Box
          sx={{
            pt: isMobile ? 13 : 18,
            pb: isMobile ? 2 : 3,
            px: isMobile ? 1 : 3,
            textAlign: "center",
            borderRadius: isMobile ? "16px" : "24px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Header - Non-scrollable */}
          <Box sx={{ mb: 2, flex: 0 }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                color: theme.palette.text.primary,
                mb: 0.5,
                fontSize: isMobile ? "1.1rem" : "1.5rem",
              }}
            >
              Communication Essentials LLC
            </Typography>
            <Typography
              variant="caption"
              sx={{
                fontWeight: 900,
                fontSize: "inherit",
                color: theme.palette.text.primary,
                display: "block",
              }}
            >
              Communications, Redefined.
            </Typography>
          </Box>

          {/* Save Contact Button */}
          <Box sx={{ mb: 3 }}>
            <Button
              variant="contained"
              fullWidth
              onClick={handleSaveContact}
              sx={{
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.background.alt,
                borderRadius: isMobile ? "12px" : "15px",
                fontWeight: "bold",
                textTransform: "none",
                fontSize: isMobile ? "14px" : "15px",
                py: isMobile ? 1.2 : 1.5,
                "&:hover": {
                  backgroundColor: theme.palette.primary[600],
                },
              }}
            >
              Save Contact
            </Button>
          </Box>

          {/* Contact Items */}
          <Stack
            spacing={2}
            sx={{
              p: 1,
            }}
          >
            {contactItems.map((item) => (
              <Card
                key={item.id}
                component={item.href ? "a" : "div"}
                href={item.href || undefined}
                target={
                  item.href &&
                  (item.id === "linkedin" ||
                    item.id === "email" ||
                    item.id === "website")
                    ? "_blank"
                    : undefined
                }
                rel={
                  item.href &&
                  (item.id === "linkedin" ||
                    item.id === "email" ||
                    item.id === "website")
                    ? "noopener noreferrer"
                    : undefined
                }
                sx={{
                  height: isMobile ? 60 : 65,
                  minHeight: isMobile ? 60 : 65,
                  backgroundColor: theme.palette.background.default,
                  borderRadius: isMobile ? "12px" : "15px",
                  display: "flex",
                  alignItems: "center",
                  p: isMobile ? 1.5 : 2,

                  boxShadow: 2,
                  textDecoration: "none",
                  cursor: item.href ? "pointer" : "default",
                  "&:hover": item.href
                    ? {
                        boxShadow: 4,
                        transform: "translateY(-2px)",
                        transition: "all 0.2s ease",
                      }
                    : {},
                }}
              >
                {/* Icon */}
                <Box
                  sx={{
                    minWidth: isMobile ? 40 : 50,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {item.icon}
                </Box>

                {/* Text Content */}
                <Box sx={{ ml: isMobile ? 1.5 : 2, flex: 1, textAlign: "start" }}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "bold",
                      color: theme.palette.text.primary,
                      fontSize: isMobile ? "16px" : "18px",
                    }}
                  >
                    {item.label}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      color: theme.palette.primary.main,
                      fontSize: isMobile ? "10px" : "14px",
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {item.value}
                  </Typography>
                </Box>
              </Card>
            ))}

            {/* Divider */}
            <Divider sx={{ my: 2 }} />

            {/* Reviews Section */}
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  color: theme.palette.text.primary,
                  textAlign: "start",
                  fontSize: isMobile ? "1.1rem" : "1.5rem",
                }}
              >
                Reviews
              </Typography>
              <Button
                variant="contained"
                size="small"
                component="a"
                href="https://g.page/r/CUdEFajc_XXREBM/review"
                target="_blank"
                rel="noopener noreferrer"
                startIcon={<AddIcon />}
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  color: theme.palette.background.alt,
                  borderRadius: isMobile ? "8px" : "10px",
                  fontWeight: "bold",
                  textTransform: "none",
                  fontSize: isMobile ? "11px" : "12px",
                  py: isMobile ? 0.4 : 0.5,
                  px: isMobile ? 1.2 : 1.5,
                  minWidth: "auto",
                  "&:hover": {
                    backgroundColor: theme.palette.primary[600],
                  },
                }}
              >
                Add Review
              </Button>
            </Box>

            {/* Reviews List */}
            {reviews.map((review) => (
              <Box
                key={review.id}
                sx={{
                  backgroundColor: theme.palette.background.default,
                  borderRadius: isMobile ? "12px" : "15px",
                  boxShadow: 2,
                  mb: 2,
                  overflow: "visible",
                  transition: "all 0.2s ease",
                  border: `1px solid ${theme.palette.divider}`,
                  display: "block",
                  width: "100%",
                }}
              >
                {/* Header with gradient */}
                <Box
                  sx={{
                    backgroundColor: theme.palette.primary.main,
                    p: isMobile ? 1.5 : 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderRadius: isMobile ? "12px 12px 0 0" : "15px 15px 0 0",
                    position: "relative",
                  }}
                >
                  <Avatar
                    sx={{
                      bgcolor: theme.palette.background.default,
                      color: theme.palette.primary.main,
                      width: isMobile ? 45 : 50,
                      height: isMobile ? 45 : 50,
                      fontSize: isMobile ? "14px" : "16px",
                      fontWeight: "bold",
                      border: isMobile ? `2px solid ${theme.palette.background.default}` : `3px solid ${theme.palette.background.default}`,
                    }}
                  >
                    {review.avatar}
                  </Avatar>
                  
                  <Box sx={{ 
                    position: "absolute",
                    left: "50%",
                    transform: "translateX(-50%)",
                    textAlign: "center",
                  }}>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontWeight: "bold",
                        color: theme.palette.background.default,
                        fontSize: isMobile ? "14px" : "16px",
                      }}
                    >
                      {review.name}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        color: theme.palette.background.default,
                        fontSize: isMobile ? "11px" : "12px",
                        opacity: 0.9,
                      }}
                    >
                      {getRelativeTime(review.date)}
                    </Typography>
                  </Box>

                  <OpenInNewIcon 
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(review.link, '_blank');
                    }}
                    sx={{ 
                      color: theme.palette.background.default, 
                      fontSize: 20,
                      opacity: 0.8,
                      cursor: "pointer",
                      transition: "opacity 0.2s ease",
                      "&:hover": {
                        opacity: 1,
                      },
                    }} 
                  />
                </Box>

                {/* Content */}
                {review.text && <Box sx={{ p: isMobile ? 2 : 2.5, display: "block" }}>
                  {/* Review Text */}
                  {review.text && (
                    <Box sx={{ display: "block" }}>
                      <Typography
                        component="span"
                        sx={{
                          color: theme.palette.primary.main,
                          fontSize: isMobile ? "20px" : "24px",
                          lineHeight: 0,
                          mr: 0.5,
                        }}
                      >
                        "
                      </Typography>
                      <Typography
                        component="span"
                        variant="body2"
                        sx={{
                          color: theme.palette.text.primary,
                          lineHeight: 1.7,
                          fontSize: isMobile ? "13px" : "14px",
                          fontStyle: "italic",
                        }}
                      >
                        {review.text}
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          color: theme.palette.primary.main,
                          fontSize: isMobile ? "20px" : "24px",
                          lineHeight: 0,
                          ml: 0.5,
                        }}
                      >
                        "
                      </Typography>
                    </Box>
                  )}
                </Box>}
                

                {review.text && <Divider  />}

                {/* Stars Footer */}
                <Box
                  sx={{
                    
                    //borderTop: `1px solid ${theme.palette.error.main}`,
                    px: isMobile ? 2 : 2.5,
                    py: isMobile ? 1.2 : 1.5,
                    backgroundColor: `${theme.palette.background.default}`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: isMobile ? "0 0 12px 12px" : "0 0 15px 15px",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    {[...Array(5)].map((_, index) => (
                      <StarIcon
                        key={index}
                        sx={{
                          color: index < review.rating ? "#FFC107" : theme.palette.divider,
                          fontSize: isMobile ? 20 : 22,
                          mr: 0.3,
                        }}
                      />
                    ))}
                    <Typography
                      variant="body2"
                      sx={{
                        ml: 1,
                        color: theme.palette.text.secondary,
                        fontWeight: "bold",
                      }}
                    >
                      {review.rating}.0
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ))}
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default OperationsCard;
